import VueECharts from 'vue-echarts'

// 排行
export function rankingBar({ names = [], counts = [] } = {}) {
  return {
    tooltip: {
      trigger: 'axis',
      confine: true,
      axisPointer: {
        type: 'none'
      },
      formatter: '{b}<br/>数量：{c}'
    },
    grid: {
      top: 20,
      left: '3%',
      right: '8%',
      bottom: 0,
      containLabel: true
    },
    graphic: {
      type: 'text',
      // 相对父元素居中
      left: 'center',
      // 相对父元素居中
      top: 'middle',
      style: {
        fill: '#fff',
        text: names.length === 0 ? '无预警' : '',
        font: '14px Microsoft YaHei'
      }
    },
    xAxis: [{
        show: false
      },
      {
        show: false
      }
    ],
    yAxis: {
      type: 'category',
      inverse: true,
      axisLine: {
        show: false
      },
      axisTick: {
        show: false
      },
      axisLabel: {
        color: '#fff',
        interval: 0,
        fontSize: 10,
        formatter: function (item, index) {
          if (index < 3) {
            return ['{top3|', index + 1, '}'].join(' ')
          } else {
            return ['{top7|', index + 1, '}'].join(' ')
          }
        },
        rich: {
          top3: {
            color: 'rgb(255, 161, 0)',
          },
          top7: {
            color: 'rgb(0, 151, 136)'
          }
        }
      },
      data: names
    },
    series: [{
        type: 'bar',
        barWidth: '20%',
        label: {
          show: true,
          position: 'right',
          textStyle: {
            color: '#fff'
          }
        },
        itemStyle: {
          color: {
            type: 'linear',
            x: 0,
            y: 0,
            x2: 1,
            y2: 0,
            colorStops: [{
              offset: 0,
              color: 'rgba(255, 56, 106, .5)'
            }, {
              offset: 1,
              color: 'rgba(255, 56, 106, .8)'
            }],
            globalCoord: false
          }
        },
        data: counts
      },
      {
        type: 'bar',
        xAxisIndex: 1,
        barWidth: '20%',
        barGap: '-100%',
        itemStyle: {
          color: 'transparent'
        },
        label: {
          show: true,
          color: '#fff',
          fontSize: 10,
          position: [0, -15],
          formatter: data => names[data.dataIndex]
        },
        data: counts
      }
    ]
  }
}

// 单柱状图（排名）
export function singleBar({ names = [], counts = [] } = {}) {
  return {
    tooltip: {
      trigger: 'axis',
      confine: true,
      axisPointer: {
        type: 'shadow'
      }
    },
    grid: {
      top: 20,
      left: '3%',
      right: '8%',
      bottom: 0,
      containLabel: true
    },
    xAxis: {
      show: false
    },
    yAxis: {
      type: 'category',
      inverse: true,
      axisLine: {
        show: false
      },
      axisTick: {
        show: false
      },
      axisLabel: {
        color: '#fff',
        interval: 0,
        fontSize: 10,
        formatter: function (item, index) {
          if (index < 3) {
            return ['{top3|', index + 1, '}'].join(' ')
          } else {
            return ['{top7|', index + 1, '}'].join(' ')
          }
        },
        rich: {
          top3: {
            color: '#fff',
            backgroundColor: 'rgb(255, 161, 0)',
            width: 16,
            height: 16,
            align: 'center',
            borderRadius: 8
          },
          top7: {
            color: '#fff',
            backgroundColor: 'rgb(0, 151, 136)',
            width: 16,
            height: 16,
            align: 'center',
            borderRadius: 8
          }
        }
      },
      zlevel: 1,
      data: names
    },
    graphic: {
      type: 'text',
      // 相对父元素居中
      left: 'center',
      // 相对父元素居中
      top: 'middle',
      style: {
        fill: '#fff',
        text: names.length === 0 ? '无预警' : '',
        font: '14px Microsoft YaHei'
      }
    },
    series: [{
      name: '数量',
      type: 'bar',
      barWidth: 12,
      label: {
        show: true,
        position: 'insideLeft',
        formatter: function (item) {
          return ['{left|' + item.name + '}', '{right|' + item.value + '}'].join(' ')
        },
        rich: {
          left: {
            color: '#fff',
            fontSize: 10
          },
          right: {
            color: '#fff',
            fontSize: 10
          }
        }
      },
      itemStyle: {
        color: {
          type: 'linear',
          x: 0,
          y: 0,
          x2: 1,
          y2: 0,
          colorStops: [{
            offset: 0,
            color: 'rgba(255, 56, 106, 1)'
          }, {
            offset: 1,
            color: 'rgba(255, 56, 106, .8)'
          }],
          globalCoord: false
        }
      },
      data: counts
    }]
  }
}

// 双向柱状图（建筑与设备）
export function bilateralBar({ buildingCount = [], buindlingCategory = [], deviceCount = [] } = {}) {
  // var myData = ['高层建筑、民用住宅', '公共设施、人员密集场所', '企事业单位、厂矿企业', '仓库、仓储场所', '液化石油类场所', '地下建筑', '化工场所', '九小场所', '学校', '森林', '农副业生产场所', '古建筑、旅游场所', '非盈利性民政福利机构', '其他场所'];
  return {
    tooltip: {
      trigger: 'axis',
      confine: true,
      formatter: '{b}<br/>{a}: {c}',
      axisPointer: {
        type: 'shadow',
      }
    },
    grid: [{
        top: 22,
        left: '4%',
        bottom: 5,
        width: '46%'
      },
      {
        top: 18,
        left: '50%',
        bottom: 5,
        width: 0
      },
      {
        top: 22,
        right: '4%',
        bottom: 5,
        width: '46%'
      }
    ],
    xAxis: [{
        gridIndex: 0,
        inverse: true,
        show: false
      },
      {
        gridIndex: 1,
        show: false
      },
      {
        gridIndex: 2,
        show: false
      }
    ],
    yAxis: [{
        gridIndex: 0,
        inverse: true,
        show: false,
        data: buindlingCategory
      },
      {
        gridIndex: 1,
        type: 'category',
        position: 'left',
        inverse: true,
        axisLine: {
          show: true,
          lineStyle: {
            color: '#009788'
          }
        },
        axisTick: {
          show: false
        },
        axisLabel: {
          show: true,
          color: '#fff',
          fontSize: 10,
          padding: [0, 0, 20, 0],
          interval: 0
        },
        zlevel: 1,
        data: buindlingCategory
      },
      {
        gridIndex: 2,
        inverse: true,
        show: false,
        data: buindlingCategory
      }
    ],
    graphic: {
      elements: [{
          type: 'group',
          top: 8,
          left: '4%',
          cursor: 'default',
          children: [{
              type: 'rect',
              shape: {
                width: 10,
                height: 10
              },
              style: {
                fill: '#009788'
              }
            },
            {
              type: 'text',
              style: {
                x: 14,
                y: -1,
                fill: '#fff',
                text: '建筑',
                font: '12px Microsoft YaHei'
              }
            }
          ]
        },
        {
          type: 'group',
          top: 8,
          right: '4%',
          cursor: 'default',
          children: [{
              type: 'rect',
              shape: {
                width: 10,
                height: 10
              },
              style: {
                fill: '#ffa100'
              }
            },
            {
              type: 'text',
              style: {
                x: 14,
                y: -1,
                fill: '#fff',
                text: '当前异常设备',
                font: '12px Microsoft YaHei'
              }
            }
          ]
        }
      ]
    },
    series: [{
        name: '建筑',
        type: 'bar',
        barWidth: 16,
        label: {
          show: true,
          color: '#fff',
          formatter: ({ value }) => {
            return value > 0 ? value : ''
          }
        },
        itemStyle: {
          color: {
            type: 'linear',
            x: 1,
            y: 0,
            x2: 0,
            y2: 0,
            colorStops: [{
              offset: 0,
              color: 'rgba(0, 151, 136, .4)'
            }, {
              offset: 1,
              color: 'rgba(0, 151, 136, .7)'
            }],
            globalCoord: false
          }
        },
        data: buildingCount
      },
      {
        name: '当前异常设备',
        type: 'bar',
        barWidth: 16,
        label: {
          show: true,
          color: '#fff',
          formatter: ({ value }) => {
            return value > 0 ? value : ''
          }
        },
        xAxisIndex: 2,
        yAxisIndex: 2,
        itemStyle: {
          color: {
            type: 'linear',
            x: 0,
            y: 0,
            x2: 1,
            y2: 0,
            colorStops: [{
              offset: 0,
              color: 'rgba(255, 161, 0, .4)'
            }, {
              offset: 1,
              color: 'rgba(255, 161, 0, .7)'
            }],
            globalCoord: false
          }
        },
        data: deviceCount
      }
    ]
  }
}

// 地图
export function mapOption({ map = {}, mapInfo = {}, highlights = [] } = {}, levelData = []) {
  if (!map) {
    return {}
  }
  let regions = []
  let scatterData = []
  // 经纬度数据
  let { features } = map

  VueECharts.registerMap(mapInfo.pinyin, map)

  // 高亮区域及散点气泡数据
  highlights.forEach(item => {
    let feature = features.find(val => val.id == item.code)
    regions.push({
      code: item.code,
      name: feature.properties.name,
      type: item.type,
      itemStyle: {
        areaColor: 'rgba(251, 114, 147, 0.8)'
      },
      emphasis: {
        itemStyle: {
          areaColor: 'rgba(251, 114, 147, 0.5)'
        }
      }
    })

    if (item.total != 0) {
      scatterData.push({
        code: item.code,
        name: feature.properties.name,
        type: item.type,
        value: [...feature.properties.cp, item.total, ...item.part]
      })
    }
  })

  return {
    tooltip: {
      trigger: 'item',
      formatter: params => {
        let str = params.value.slice(3).map(item => `${levelData.find(obj => item.level == obj.level).title}：${item.value}`).join('<br/>')
        return `${params.name}<br/>${str}`
      }
    },
    // 地理坐标系组件
    geo: {
      // 地图类型；默认为空
      map: mapInfo.pinyin,
      // 是否开启鼠标缩放和平移漫游；默认不开启
      // roam: true,
      // 图形上的文本标签
      label: {
        show: true,
        color: '#fff'
      },
      // 地图区域的多边形图形样式
      itemStyle: {
        color: {
          type: 'radial',
          x: 0.5,
          y: 0.5,
          r: 0.8,
          colorStops: [{
            offset: 0,
            color: 'rgba(147, 235, 248, 0)'
          }, {
            offset: 1,
            color: 'rgba(147, 235, 248, .3)'
          }]
        },
        borderWidth: 1,
        borderColor: 'dodgerblue'
      },
      // 高亮状态下的多边形和标签样式
      emphasis: {
        label: {
          color: '#fff'
        },
        itemStyle: {
          areaColor: 'rgba(56, 155, 183, 0.5)'
        }
      },
      // 在地图中对特定的区域配置样式
      regions,
      zoom: 1.2
    },
    series: [
      {
        type: 'scatter',
        coordinateSystem: 'geo',
        symbol: 'pin',
        // symbolSize: function(val) {
        //   return val[2]
        // },
        symbolSize: 50,
        label: {
          show: true,
          textStyle: {
            color: '#fff',
            fontSize: 10
          },
          formatter: '{@[2]}'
        },
        itemStyle: {
          color: '#09747c'
        },
        zlevel: 6,
        data: scatterData
      }
      // {
      //   name: 'Top 5',
      //   type: 'effectScatter',
      //   coordinateSystem: 'geo',
      //   data: [ { name: '合肥', value: [ 117.27, 31.86, 229 ] }, { name: '武汉', value: [ 114.31, 30.52, 273 ] }, { name: '大庆', value: [ 125.03, 46.58, 279 ] } ],
      //   symbolSize: val => val[2] / 20,
      //   showEffectOn: 'render',
      //   rippleEffect: {
      //     brushType: 'stroke'
      //   },
      //   hoverAnimation: true,
      //   label: {
      //     normal: {
      //       formatter: '{b}',
      //       position: 'right',
      //       show: true
      //     }
      //   },
      //   itemStyle: {
      //     normal: {
      //       color: '#f4e925',
      //       shadowBlur: 10,
      //       shadowColor: '#333'
      //     }
      //   }
      // }
    ]
  }
}

// 堆积折线图
export function stackedLine({ date = [], source = [] } = {}) {
  let opt = {
    type: 'linear',
    x: 0,
    y: 0,
    x2: 0,
    y2: 1,
    globalCoord: false
  }
  let colors = [
    {
      ...opt,
      colorStops: [{
        offset: 0,
        color: 'rgba(219, 50, 51, 0.3)'
      }, {
        offset: 1,
        color: 'rgba(219, 50, 51, 0)'
      }]
    },
    {
      ...opt,
      colorStops: [{
        offset: 0,
        color: 'rgba(0, 136, 212, 0.3)'
      }, {
        offset: 1,
        color: 'rgba(0, 136, 212, 0)'
      }]
    },
    {
      ...opt,
      colorStops: [{
        offset: 0,
        color: 'rgba(137, 189, 27, 0.3)'
      }, {
        offset: 1,
        color: 'rgba(137, 189, 27, 0)'
      }]
    },
    {
      ...opt,
      colorStops: [{
        offset: 0,
        color: 'rgba(255, 219, 92, 0.3)'
      }, {
        offset: 1,
        color: 'rgba(255, 219, 92, 0)'
      }]
    }
  ]
  let itemColors = ['rgb(219, 50, 51)', 'rgb(0, 136, 212)', 'rgb(137, 189, 27)', 'rgb(255, 219, 92)']
  let itemBorderColors = ['rgba(219, 50, 51, 0.2)', 'rgba(0, 136, 212, 0.2)', 'rgba(137, 189, 27, 0.2)', 'rgba(255, 219, 92, 0.2)']
  let seriesData = []
  let legendData = []
  
  source.forEach((item, index) => {
    seriesData.push({
      name: item.name,
      type: 'line',
      smooth: true,
      symbol: 'circle',
      symbolSize: 3,
      showSymbol: false,
      lineStyle: {
        width: 1
      },
      areaStyle: {
        color: colors[index],
        shadowColor: 'rgba(0, 0, 0, 0.1)',
        shadowBlur: 10
      },
      itemStyle: {
        color: itemColors[index],
        borderColor: itemBorderColors[index],
        borderWidth: 12
      },
      data: item.value
    })

    legendData.push(item.name)
  })

  return {
    tooltip: {
      trigger: 'axis',
      confine: true,
      axisPointer: {
        type: 'cross',
        crossStyle: {
          color: '#999'
        },
        label: {
          formatter: ({ value }) => {
            return typeof value == 'number' ? value.toFixed(0) : value
          },
          backgroundColor: '#ff6d9c'
        }
      }
    },
    legend: {
      top: 5,
      data: legendData,
      textStyle: {
        color: '#bababa',
        fontSize: 12
      }
    },
    grid: {
      top: 40,
      right: 20,
      bottom: 20,
      left: 20,
      containLabel: true
    },
    xAxis: {
      type: 'category',
      boundaryGap: false,
      axisLine: {
        lineStyle: {
          color: '#bababa'
        }
      },
      data: date
    },
    yAxis: {
      type: 'value',
      minInterval: 1,
      axisLine: {
        lineStyle: {
          color: '#bababa'
        }
      },
      axisLabel: {
        margin: 10,
        textStyle: {
          fontSize: 12
        }
      },
      splitLine: {
        show: false
      }
    },
    series: seriesData
  }
}

// 柱状图+折线图
export function lineBar({ time = [], list = [] } = {}) {
  let legendData = []
  let lineData = []
  let barData = []
  let colors = [ { start: 'rgb(173, 39, 49)', end: 'rgba(173, 39, 49, 0.2)' }, { start: 'rgb(0, 136, 212)', end: 'rgba(0, 136, 212, 0.2)' }, { start: 'rgba(137, 189, 27, 0.3)', end: 'rgb(137, 189, 27)' }, { start: 'rgba(195, 175, 49, 0.3)', end: 'rgb(195, 175, 49)' } ]
  list.forEach((item, index) => {
    legendData.push(item.title)
    if (index <= 1) {
      lineData.push({
        name: item.title,
        type: 'line',
        smooth: true,
        symbol: 'circle',
        symbolSize: 5,
        lineStyle: {
          width: 1
        },
        itemStyle: {
          color: colors[index].start,
          borderColor: colors[index].end,
          borderWidth: 12
        },
        data: item.value
      })
    } else {
      barData.push({
        name: item.title,
        type: 'bar',
        barWidth: 15,
        barGap: 0,
        itemStyle: {
          color: {
            type: 'linear',
            x: 0,
            y: 1,
            x2: 0,
            y2: 0,
            colorStops: [{
              offset: 0,
              color: colors[index].start
            }, {
              offset: 1,
              color: colors[index].end
            }],
            globalCoord: false
          }
        },
        data: item.value
      })
    }
  })

  return {
    tooltip: {
      trigger: 'axis',
      confine: true,
      axisPointer: {
        type: 'cross',
        crossStyle: {
          color: '#999'
        },
        label: {
          formatter: ({ value }) => {
            return typeof value == 'number' ? value.toFixed(0) : value
          },
          backgroundColor: '#ff6d9c'
        }
      }
    },
    legend: {
      top: 5,
      data: legendData,
      textStyle: {
        color: '#fff'
      }
    },
    grid: {
      top: 40,
      right: 30,
      bottom: 5,
      left: 20,
      containLabel: true
    },
    xAxis: [{
      type: 'category',
      axisPointer: {
        type: 'shadow'
      },
      axisLine: {
        lineStyle: {
          color: '#fff'
        }
      },
      data: time
    }],
    yAxis: [{
      type: 'value',
      minInterval: 1,
      splitLine: {
        show: false
      },
      axisLine: {
        lineStyle: {
          color: '#fff'
        }
      }
    }],
    series: [ ...lineData, ...barData ]
  }
}

// 双柱状图
export function dualBar(levelData = [], source = []) {
  let colors = [
    [{
      offset: 0,
      color: 'rgba(255, 56, 106, 0.3)'
    }, {
      offset: 1,
      color: 'rgba(255, 56, 106, 0.8)'
    }],
    [{
      offset: 0,
      color: 'rgba(0, 136, 255, 0.3)'
    }, {
      offset: 1,
      color: 'rgba(0, 136, 255, 0.8)'
    }]
  ]
  // let xAxisData = levelData.map(item => item.title)
  let legendData = []
  let seriesData = []
  source.forEach((item, index) => {
    legendData.push(item.title)
    seriesData.push({
      name: item.title,
      type: 'bar',
      barWidth: 15,
      barGap: 0,
      itemStyle: {
        color: {
          type: 'linear',
          x: 0,
          y: 1,
          x2: 0,
          y2: 0,
          colorStops: colors[index],
          globalCoord: false
        }
      },
      data: item.value
    })
  })
  return {
    tooltip: {
      trigger: 'axis',
      confine: true,
      axisPointer: {
        type: 'cross',
        crossStyle: {
          color: '#999'
        },
        label: {
          formatter: ({ value }) => {
            return typeof value == 'number' ? value.toFixed(0) : value
          },
          backgroundColor: '#ff6d9c'
        }
      }
    },
    grid: {
      top: 40,
      right: 20,
      bottom: 20,
      left: 20,
      containLabel: true
    },
    legend: {
      top: 5,
      textStyle: {
        color: '#bababa',
        fontSize: 12
      },
      data: legendData
    },
    xAxis: [{
      type: 'category',
      axisPointer: {
        type: 'shadow',
        shadowStyle: {
          color: 'rgba(0, 0, 0, .5)'  
        }
      },
      axisLine: {
        lineStyle: {
          color: '#bababa'
        }
      },
      data: levelData
    }],
    yAxis: [{
      type: 'value',
      minInterval: 1,
      splitLine: {
        show: false
      },
      axisLine: {
        lineStyle: {
          color: '#bababa'
        }
      }
    }],
    series: seriesData
  }
}

// 单饼图
export function singlePie(levelData = [], { title = '', value = [] } = {} ) {
  let pieData = []
  
  value.forEach((item, index) => {
    pieData.push({
      value: item.value,
      name: levelData[index].title,
      itemStyle: {
        color: levelData[index].color
      }
    })
  })

  return {
    tooltip: {
      trigger: 'item',
      confine: true,
      formatter: '{b} {c} 次<br/>占比 {d}%'
    },
    graphic: {
      type: 'text',
      // 相对父元素居中
      left: 'center',
      // 相对父元素居中
      top: 'middle',
      style: {
        fill: '#fff',
        text: title,
        font: '12px Microsoft YaHei'
      }
    },
    series: [{
      type: 'pie',
      radius: ['25%', '35%'],
      label: {
        show: true,
        color: '#ccc',
        formatter: '{b} {c}\n占比 {d}%',
      },
      data: pieData
    }]
  }
}